export const SearchTypeAdvancedRaw = 8 as const;
export type TSearchTypeAdvancedRaw = typeof SearchTypeAdvancedRaw;
